export default {
  GET_ANONYMOUS_EMAIL_REQUEST: '@@anonymous-emails/GET_ANONYMOUS_EMAIL_REQUEST',
  GET_ANONYMOUS_EMAIL_SUCCESS: '@@anonymous-emails/GET_ANONYMOUS_EMAIL_SUCCESS',
  GET_ANONYMOUS_EMAIL_ERROR: '@@anonymous-emails/GET_ANONYMOUS_EMAIL_ERROR',
};
